module.exports = __webpack_public_path__ + "04_veryshort_gray.15450622.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_veryshort_gray.png
// module id = b7du
// module chunks = 0